/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = typeof window == 'object' && typeof Deno != 'object';

